module.exports = __webpack_public_path__ + "static/media/Keyframe_Logo_White_Transparent_Cute.86249766.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Keyframe_Logo_White_Transparent_Cute.png
// module id = 7382
// module chunks = 0